import { composeReducers } from 'common/util/composeReducers';

import {
    ACTIONS,
} from 'forms/actions/doa';

export function submitDOASignTask(state, action) {
    if (!action || action.type !== ACTIONS.SUBMIT_DOA_SIGN_TASK) {
        return state;
    }

    const { success } = action.payload;
    const form = state.form;

    return {
        ...state,
        form: {
            ...form,
            submissionSuccess: success
        }
    };
}

export function getDOASignatureRequest(state, action){
    if (!action || action.type !== ACTIONS.GET_DOA_SIGNATURE_REQUEST) {
        return state;
    }

    const signatureRequest = action.payload;
    return {
        ...state,
        form: {
            signatureRequest,
        },
    };
}

export function unloadDOASignatureRequest(state, action) {
    if (!action || action.type !== ACTIONS.UNLOAD_DOA_SIGNATURE_REQUEST) {
        return state;
    }

    return {
        ...state,
        form: {},
    };
}

export default composeReducers(
    submitDOASignTask,
    getDOASignatureRequest,
    unloadDOASignatureRequest,
);
